import React, { useState } from 'react';
import { supabase } from '../global/supabase';
import '../global/styles.css';

// Mandatory witness-PIN reset. Shown after login whenever
// public.users.pin_reset_required is true; nothing else is reachable until a
// new PIN is saved. The PIN goes only to the set_own_pin RPC, which hashes it.
function SetPin({ userInfo, onComplete, onLogout }) {
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!/^\d{6}$/.test(pin)) {
      setError('PIN must be exactly 6 digits');
      return;
    }
    if (pin !== confirmPin) {
      setError('PINs do not match');
      return;
    }

    setLoading(true);
    const { error: rpcError } = await supabase.rpc('set_own_pin', { new_pin: pin });
    setLoading(false);

    if (rpcError) {
      setError(rpcError.message || 'Could not save your PIN. Please try again.');
      return;
    }
    setPin('');
    setConfirmPin('');
    onComplete();
  };

  return (
    <div className="container-center">
      <div className="card">
        <h2 className="title-auth">Set a New Witness PIN</h2>
        <p className="subtitle-auth">
          {userInfo?.firstName ? `${userInfo.firstName}, your` : 'Your'} previous PIN must be replaced before you can
          continue. Choose a new 6-digit PIN that you have not used before. You will enter it when you witness
          another provider's inventory entry.
        </p>

        {error && (
          <div className="message error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="new-pin" className="form-label">New PIN (6 digits)</label>
            <input
              type="password"
              id="new-pin"
              inputMode="numeric"
              autoComplete="new-password"
              maxLength={6}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
              required
              className="form-input"
              placeholder="Enter a new 6-digit PIN"
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-pin" className="form-label">Confirm New PIN</label>
            <input
              type="password"
              id="confirm-pin"
              inputMode="numeric"
              autoComplete="new-password"
              maxLength={6}
              value={confirmPin}
              onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, ''))}
              required
              className="form-input"
              placeholder="Re-enter the new PIN"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save PIN'}
          </button>
        </form>

        <div className="links">
          <div className="link-center">
            <button
              type="button"
              onClick={onLogout}
              className="link"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
            >
              Log out
            </button>
          </div>
        </div>
      </div>

      <footer className="footer">
        <p className="text-small">NarcoticTrack © 2025 NarcoticTrack Inventory System, LLC</p>
      </footer>
    </div>
  );
}

export default SetPin;
